import { useNavigate } from "react-router-dom";

const CustomHero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[88vh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c1d92943b41a7eabe8502572d1f64491.jpg"
          alt="自訂行程背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-6 lg:px-12 py-32">
        <div className="max-w-3xl">
          {/* Hot badge */}
          <div className="inline-flex items-center space-x-2 bg-orange-500 text-white rounded-full px-5 py-2 mb-8">
            <i className="ri-fire-line text-lg"></i>
            <span className="text-sm font-bold tracking-wide">全站最熱門服務 · 超過 80% 客人選擇</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
            <div>100% 由您</div>
            <div className="text-orange-400">自訂行程</div>
          </h1>

          <p className="text-xl text-white/85 mb-10 max-w-xl leading-relaxed">
            路線、天數、節奏、住宿全部由您決定。我們負責所有跨境手續、領隊及後勤，您只需專注享受旅程。
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 pt-10 border-t border-white/20 mb-10">
            {[
              { number: "1,200+", label: "自訂行程出團" },
              { number: "98%", label: "客人滿意度" },
              { number: "3天", label: "最快出發" },
            ].map((s) => (
              <div key={s.label}>
                <div className="text-3xl md:text-4xl font-bold text-orange-400 mb-1">{s.number}</div>
                <div className="text-white/60 text-sm">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => navigate("/#contact")}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <span>立即規劃我的行程</span>
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => document.getElementById("process")?.scrollIntoView({ behavior: "smooth" })}
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 px-8 py-4 rounded-full text-lg font-medium transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-xl"></i>
              <span>了解流程</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomHero;
